export default {
  computed: {
    anchorDate() {
      return this.$store.getters.selectedDate
        ? this.$store.getters.selectedDate.format("YYYY-MM-DD")
        : this.$moment().format("YYYY-MM-DD");
    },
  },
};
